import { useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetchImageCaptureAccountById,
  updateImageCaptureAccountById,
} from "./../../../../lib/api/resources/imageCaptureAccounts";
import { ImageCaptureAccountFormCard } from "./components/ImageCaptureAccountFormCard";
import { Col, Flex, message, Row } from "antd";

export const ImageCaptureAccountEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["imageCaptureAccount", id],
    queryFn: () => fetchImageCaptureAccountById(id!),
  });

  const updateMutation = useMutation({
    mutationFn: (values: any) => updateImageCaptureAccountById(id!, values),
    onSuccess: () => {
      navigate(`/image-captures/accounts/${id}`);
      message.success("ImageCapture account succesvol bijgewerkt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het bijwerken van de ImageCapture account",
      ),
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Flex vertical gap={16}>
          <ImageCaptureAccountFormCard
            initialValues={data}
            loading={isLoading}
            mutation={updateMutation}
            title="Account bijwerken"
            buttonText="Bijwerken"
          />
        </Flex>
      </Col>
    </Row>
  );
};
